<template>
    <div>
        <img
            :src="doubleBubbleImg"
            class="img"
        >
    </div>
</template>
<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        doubleBubbleImg() {
            return this.pageData.opusHistoryInfo?.doubleBubbleImg;
        }
    },
})
export default class Double extends Vue {

}
</script>

<style lang="scss" scoped>
.img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.33rem;
    width: 7.23rem;
    height: 4.05rem;
    border-radius: .21rem;
}
</style>
